import { Fragment } from "react";
import AffiliateHero from "../../../components/landing/AffiliateHero";
import FAQPreview from "../../../components/common/FAQPreview";
import PublicFooterV2 from "../../../components/ui/PublicFooterV2";
import AffiliateInfo from "../../../components/landing/AffiliateInfo";
import ClassicHowItWork from "../../../components/ui/hiw/ClassicHowItWork";
import AffiliateBenefits from "../../../components/landing/AffiliateBenefits";
import AffiliatesServicesEarning from "../../../components/landing/AffiliatesServicesEarning";
import ClosingPage from "../../../components/common/Closing";
import { ScrollRestoration } from "react-router-dom";
import { getLanguageContent } from "../../../utils/language/languageSelector";
import { AFFILIATES_SCHEMA } from "../../../utils/schemas/language/pages/affiliatesSchema";

function AffiliatePublicLandingPage({ langKey }) {
  const content = getLanguageContent(AFFILIATES_SCHEMA, langKey);

  return (
    <Fragment>
      <ScrollRestoration />
      <main className="public-v2">
        <AffiliateHero />
        <AffiliateInfo />
        <AffiliateBenefits />
        <ClassicHowItWork
          title={content.how_it_works.title}
          steps={content.how_it_works.steps}
        />
        <AffiliatesServicesEarning />
        <FAQPreview
          title={content.faq.heading}
          faqs={content.faq.items}
          ctaText={content.faq.cta}
          toggleAlt={content.faq.toggle_alt}
        />
        <ClosingPage
          title={content.closing_page.heading}
          description={content.closing_page.description}
          imageAlt={content.closing_page.image_alt}
          ctas={content.closing_page.ctas}
          containerClasses="padding-full"
        />
      </main>
      <PublicFooterV2 />
    </Fragment>
  );
}

export default AffiliatePublicLandingPage;
